import PermissionService from "../services/permissions.service";


const state = {
	permissions: [],
	groupPermissions: [],
};

const getters = {
	permissions: (state) => {
		return state.permissions;
	},
	total: (state) => {
		return state.total;
	},
	groupPermList: (state) => {
		return state.groupPermissions;
	}

};
const actions = {
	async fetchPerm({commit}) {
		try {
			const getPerResponse = await PermissionService.getPermissions();
			commit('setPermissions', getPerResponse.data);
			return true
		} catch (e) {
			return false
		}
	},
	async fetchGroupPermissions({commit}) {
		try {
			const getResGroupPermissions = await PermissionService.getGroupPermissions();
			commit('setGroup', getResGroupPermissions.data);
		} catch (e) {

		}
	},
	async editPermission({commit}, newPermission) {
		try {
			const editResponse = await PermissionService.editPermission(newPermission);
			return true;
		} catch (e) {
			return false
		}
	},
};
const mutations = {
	setPermissions(state, permissions) {
		state.permissions = permissions;
	},
	setGroup(state, resGroupPerm) {
		state.groupPermissions = resGroupPerm;
	}
};

export const permissions = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}

